import * as React from "react"
import { VisibilityContext } from "react-horizontal-scrolling-menu"
import { BiLeftArrow } from "react-icons/bi"
import { Button } from "@chakra-ui/react"
import { Icon } from "../../../common/icons"
import useWindowSize from "../../../../hooks/useWindowSize"

export const LeftArrow = ({ isLandscape }: { isLandscape?: boolean }) => {
  const { isFirstItemVisible, scrollPrev } = React.useContext(VisibilityContext)

  const { screenSize } = useWindowSize()

  return (
    <Button
      justifyContent="center"
      position="absolute"
      alignItems="center"
      background={"transperent"}
      left={screenSize.width < 350 ? "0px" : "-25px"}
      bottom={isLandscape ? "0.8rem" : "1.5rem"}
      minW="unset"
      color="black"
      padding={0}
      zIndex={100000}
      visibility={isFirstItemVisible ? "hidden" : "visible"}
      disabled={isFirstItemVisible}
      _focus={{}}
      _hover={{}}
      _active={{}}
      onClick={() => scrollPrev()}
    >
      <Icon src={BiLeftArrow} />
    </Button>
  )
}
